import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import DateRangePicker, { DateRangePickerProps } from './DateRangePicker';
import RadioGroup from '../RadioGroup';
import { DATE_RANGE_TYPE, DATE_RANGE_TYPE_SELECT_LIST } from '../../../constants/service/common/dateConstants';
import { InfiniteRangePickerStyle } from './style';

type InfiniteRangePickerProps = DateRangePickerProps;

const InfiniteRangePicker = (props: InfiniteRangePickerProps) => {
  const [rangeType, setRangeType] = useState<DATE_RANGE_TYPE>(DATE_RANGE_TYPE.DIRECT_SETTING);

  useEffect(() => {
    if (props.value?.startDate === null && props.value.endDate === null) {
      setRangeType(DATE_RANGE_TYPE.INFINITE);
    }
  }, [props.value]);

  const handleChangeType = (value: DATE_RANGE_TYPE) => {
    if (value === DATE_RANGE_TYPE.INFINITE) {
      props.onChange && props.onChange({ startDate: null, endDate: null });
    }

    if (value === DATE_RANGE_TYPE.DIRECT_SETTING) {
      props.onChange &&
        props.onChange({
          startDate: dayjs(new Date().toISOString()).format(props.format),
          endDate: dayjs(new Date().toISOString()).add(7, 'days').format(props.format),
        });
    }

    setRangeType(value);
  };

  return (
    <InfiniteRangePickerStyle>
      <RadioGroup value={rangeType} list={DATE_RANGE_TYPE_SELECT_LIST} size="large" onChange={handleChangeType} />
      {rangeType === DATE_RANGE_TYPE.DIRECT_SETTING && <DateRangePicker {...props} />}
    </InfiniteRangePickerStyle>
  );
};

export default InfiniteRangePicker;
